export default __webpack_public_path__ + "static/media/certificateImg.3718872e.png";